import { createGlobalStyle } from "styled-components";
const GlobalStyle = createGlobalStyle`

  html {
    scroll-behavior: smooth;
  }
  .ant-spin-fullscreen {
    background-color: white;
  }
  .anticon.anticon-loading.anticon-spin.ant-spin-dot {
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      width: 100%;
      height: 100%;
    }
  }
  * {
    padding: 0;
    margin: 0;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 13px;
    /* transition-duration: .4s; */
    box-sizing: border-box;
    overflow-x: hidden;
    list-style: none;
  }
  a, h2, h3, p, strong, span {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.fontePadrao};
  }
  .ant-btn-primary span {
    color: white !important;
  }
  h1 {
    font-size: 30px;
    color: ${({ theme }) => theme.colors.primaria};
    margin: 0;
  }
  h2 {
    font-size: 20px;
    color: ${({ theme }) => theme.colors.fonteLight};
  }

  @media only screen and (max-width: 1000px) {
    h1 {
      font-size: 24px;
    }
    h2 {
      font-size: 18px;
    }
  }
  body {
    background-color: ${({ theme }) => theme.colors.background};
  }
  input, button, textarea, select {
    font-family: Arial, Helvetica, sans-serif;
  }
  input:focus, textarea:focus, select:focus, button, button:focus{
    outline: none;
  }
  table {
    border-spacing: 0;
  }
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  button {
    background: none;
    border: none;
  }

  input, select {
    border-radius: 2px;
    border: 1px solid ${({ theme }) => theme.colors.secundaria};
    padding: 4px 8px;
    background-color: ${({ theme }) => theme.colors.background};
  }
  
  select {
    padding: 7px 10px;
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background: ${({ theme }) => theme.colors.background};
  }
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.primaria};
    border-radius: 8px;
    transition-duration: box-shadow 0.6s;
    &:hover {
      box-shadow: inset 0 0 5px ${({ theme }) => theme.colors.secundaria};
    }
  }
  ::-webkit-scrollbar-corner {
    width: 0;
    height: 0;
  }

  .btnGroup {
    display: flex;
    width: 250px;
    justify-content: space-between;
    @media print {
      display: none;
    }
  }
`;

export default GlobalStyle;
